import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {post, patch} from '../core/http';
import {API} from '../core/constants';
import {docId} from '../core/Firebase';
import CoverImage from "./CoverImage";
import MultiSelect from "./MultiSelect";
import EntitySelect from "./EntitySelect";
import Modal from './ui/Modal';

const EventForm = ({event, onFormSubmit, onCancel}) => {
    const [id, setId] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [tags, setTags] = useState([]);
    const [entityIds, setEntityIds] = useState([]);

    useEffect(() => {
        if (!event?.id) {
            setId(docId());
        } else {
            setId(event.id);
        }

        setImageUrl(event?.cover);
        setEntityIds(event?.entityIds || []);
    }, [event]);

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm({
        defaultValues: event
    });

    const onSubmit = async (data) => {
        const payload = {
            ...data,
            id,
            tags,
            entityIds
        };

        try {
            let result;
            if (event?.id) {
                payload.cover = event.cover || imageUrl;
                result = await patch(`${API}/events/${id}`).send({
                    ...payload,
                    cover: imageUrl
                });
                if (result.body) {
                    console.log(result.body);
                }
            } else {
                payload.cover = imageUrl;
                result = await post(`${API}/events`).send({
                    ...payload,
                    cover: imageUrl
                });
            }

            onFormSubmit(result.body);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Modal title={event ? event.title : 'Add new event'} description={event ? `ID: ${event.id}` : null} onClose={onCancel} wide>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
                {imageUrl ? (
                    <div>
                        <img className="rounded-md mb-1.5 max-h-40 object-cover" src={imageUrl} alt=""/>
                        <button type="button" className="btn btn-ghost btn-xs" onClick={() => setImageUrl(null)}>Change cover</button>
                    </div>
                ) : (
                    <CoverImage type={"event"} id={id} onUploadComplete={setImageUrl}/>
                )}

                <label className="block">
                    <span className="label-text text-xs font-semibold">Title</span>
                    <input
                        className="input input-bordered input-sm w-full mt-1"
                        {...register('title', {required: 'Title is required'})}
                        placeholder="Title"
                    />
                    {errors.title && <p className="text-error text-xs mt-1">{errors.title.message}</p>}
                </label>

                <label className="block">
                    <span className="label-text text-xs font-semibold">Summary</span>
                    <textarea
                        className="textarea textarea-bordered w-full mt-1"
                        {...register('summary', {required: 'Summary is required'})}
                        placeholder="Summary"
                        rows={6}
                    />
                    {errors.summary && <p className="text-error text-xs mt-1">{errors.summary.message}</p>}
                </label>

                <div>
                    <span className="label-text text-xs font-semibold">Categories</span>
                    <MultiSelect options={['orange', 'apple' ]} preselectedTags={event?.tags} onTagSelected={setTags} />
                    {errors.categories && <p className="text-error text-xs mt-1">{errors.categories.message}</p>}
                </div>

                <div>
                    <span className="label-text text-xs font-semibold">Related entities</span>
                    <EntitySelect selectedIds={entityIds} onChange={setEntityIds} />
                </div>

                <label className="block">
                    <span className="label-text text-xs font-semibold">Status</span>
                    <select className="select select-bordered select-sm w-full mt-1" {...register('status')}>
                        <option value="draft">Draft</option>
                        <option value="publish">Publish</option>
                    </select>
                </label>

                <div className="flex gap-2 pt-2">
                    <button type="button" className="btn btn-ghost btn-sm flex-1" onClick={() => onCancel()}>
                        Cancel
                    </button>
                    <input className="btn btn-primary btn-sm flex-1" type="submit" value={event ? 'Save' : 'Create'} />
                </div>
            </form>
        </Modal>
    );
};

export default EventForm;
